import React from "react";
import { Container, Typography } from "@mui/material";
import Logo from "../../components/Logo";
import RegisterForm from "../../components/RegisterForm";

const Register = () => {
  return (
    <Container maxWidth="sm" style={{ marginTop: "64px", textAlign: "center" }}>
      <Logo height={100} width={100} style={{ marginBottom: "16px" }} />
      <Typography variant="h6" gutterBottom>
        Crear tu cuenta en GerenUC
      </Typography>
      <RegisterForm />
    </Container>
  );
};

export default Register;
